<template>
  <div>
    <div class="grid-wrapper results-matches">
      <CondensedMatchCard
        v-for="match of results.matches"
        :key="match.id"
        :match="match" />
    </div>

    <h3 v-if="results && !results.matches.length">
      There were no products matched or featured matches available
    </h3>
  </div>
</template>

<script>
import CondensedMatchCard from './CondensedMatchCard'

export default {
  name: 'Results',
  components: {
    CondensedMatchCard,
  },

  props: {
    results: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style lang="scss" scoped>
.results-matches {
  width: 100%;
  grid-template-columns: 1fr;
}
</style>
